import {
  categoryMerchandising,
  KlevuFetch,
  kmcRecommendation,
  sendRecommendationViewEvent,
  applyFilters,
  KlevuSearchSorting,
} from '@klevu/core'
import { initializeKlevu } from './klevu-init'

const getKlevuCollection = async (collectionTitle, filters = []) => {
  initializeKlevu()

  const modifiers = []
  if (Array.isArray(filters) && filters.length > 0) {
    modifiers.push(applyFilters(filters))
  }

  const products = await KlevuFetch(
    categoryMerchandising(
      collectionTitle,
      {
        groupCondition: {
          groupOperator: 'ANY_OF',
          conditions: [
            {
              key: 'tags',
              valueOperator: 'EXCLUDE',
              singleSelect: false,
              values: ['type_Legacy', 'display_Search'],
            },
          ],
        },
        id: 'collection',
        limit: 16,
        sort: KlevuSearchSorting.Relevance,
      },
      ...modifiers
    )
  )
  return products
}

const getProductRecommendations = async (id = null) => {
  initializeKlevu()

  const recommendationId =
    id ||
    (Pura.environment.production
      ? 'k-fe4fc7d2-a5d8-415f-889a-4eee495c8e7e'
      : 'k-a39a715c-2c7a-414a-9064-a9e7212ee86c')

  const config = {
    id: 'productRecs',
  }

  if (!id && Pura?.product) {
    config.currentProductId = Pura.product.variants[0].id
    config.itemGroupId = Pura.product.id
  }

  const products = await KlevuFetch(
    kmcRecommendation(
      recommendationId,
      config,
      sendRecommendationViewEvent('Product Recommendations')
    )
  )
  return products
}

export { getKlevuCollection, getProductRecommendations }
